// extracted by mini-css-extract-plugin
export default {"missingImageBox":"styles_missingImageBox__jpYnb","container":"styles_container__vI9JN","centered":"styles_centered__dxjy3"};